import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import { T } from '../../../utils/I18n/I18n'
import StructuralDataBreadcrumbs from '../../../components/StructuralData/StructuralDataBreadcrumbs';
import './Breadcrumbs.scss';

// Transform a link to a path that we can use
const extractPath = (url) => {
    // Assume that it's always safe to redirect to /
    const defaultRedirect = "/";

    try {
        // Sprawdzamy czy URL jest dostępny (może nie być w środowisku SSR)
        if (typeof URL !== 'undefined' && url) {
            // Sprawdzamy czy url jest poprawnym adresem
            if (url.startsWith('http') || url.startsWith('//')) {
                const parsedUrl = new URL(url);
                return parsedUrl.pathname || defaultRedirect;
            } 
            
            // Jeśli to nie jest pełny URL, ale zaczyna się od /
            if (url.startsWith('/')) {
                return url;
            }
            
            // Inny format - zwróć z dodanym /
            return `/${url}`;
        }
    } catch (error) {
        console.error('Error parsing URL:', error, url);
    }
    
    return defaultRedirect;
}

const Breadcrumbs = ({routeData, isCategory, name}) => {
    // Handle search
    if(!routeData && name){
        return (
            <div className="breadcrumbs">
                <Link className="breadcrumbs__link" to="/">
                    <T id="home" />
                </Link>
                <span><T id="searchResult.results" name={name}/></span>
            </div>
        )
    }

    // Handle category & product
    // Sprawdzamy, czy routeData istnieje, aby uniknąć błędów
    if (!routeData) {
        console.warn('No route data provided to Breadcrumbs');
        return (
            <div className="breadcrumbs">
                <Link className="breadcrumbs__link" to="/">
                    <T id="home" />
                </Link>
            </div>
        );
    }
    
    // Bezpieczne pobieranie breadcrumbs
    const breadcrumbs = routeData.breadcrumbs || [];
    
    return <div className="breadcrumbs">
                {/* Dodajemy warunek sprawdzający, czy wszystkie wymagane dane są dostępne */}
                {breadcrumbs && (
                    <StructuralDataBreadcrumbs 
                        breadcrumbs={breadcrumbs}
                        isCategory={isCategory}
                        routeData={routeData}
                        name={name}
                    />
                )}
                    
        {isCategory && <Link className="breadcrumbs__link" to="/">
            <T id="home" />
        </Link>}
        
        {Array.isArray(breadcrumbs) && breadcrumbs.map((crumb, index) => {
            // Sprawdzamy, czy crumb ma wszystkie wymagane właściwości
            if (!crumb || !crumb.category_name) {
                return null;
            }
            
            // Używamy indeksu jako fallback dla klucza
            const key = crumb.category_level || `breadcrumb-${index}`;
            const url = crumb.category_url ? extractPath(crumb.category_url) : '/';
            
            return (
                <Link
                    to={url}
                    className="breadcrumbs__link"
                    key={key}
                >
                    {crumb.category_name}
                </Link>
            );
        }).filter(Boolean)}
        
        {!isCategory && routeData.canonical_url && (
            <Link className="breadcrumbs__link" to={`/${routeData.canonical_url}`}>
                {routeData.name || ''}
            </Link>
        )}
        
        <span>{isCategory && routeData ? (routeData.name || '') : (name || '')}</span>
    </div>
}


Breadcrumbs.propTypes = {
    routeData: PropTypes.object,
    name: PropTypes.string,
};

export default React.memo(Breadcrumbs);